import { useOrgCollection } from './useOrgCollection';
import {
  SUBCOLLECTION_COMMERCIAL_DOCUMENTS,
  SUBCOLLECTION_CUSTOMERS,
  SUBCOLLECTION_FINANCING_APPLICATIONS,
  SUBCOLLECTION_FINANCING_CASES,
} from '../lib/firestorePaths';
import type { CommercialDocument, Customer, FinancingApplication, FinancingCase } from '../types';
import { useOrg } from '../context/OrgContext';

export function useOrgCustomers() {
  const { org } = useOrg();
  const { items, loading } = useOrgCollection<Customer>(org?.id ?? null, SUBCOLLECTION_CUSTOMERS);
  return { customers: items.filter((c) => !c.archivedAt), loading };
}

export function useOrgDocuments() {
  const { org } = useOrg();
  const { items, loading } = useOrgCollection<CommercialDocument>(
    org?.id ?? null,
    SUBCOLLECTION_COMMERCIAL_DOCUMENTS
  );
  return { documents: items.filter((d) => d.status !== 'archived'), loading };
}

export function useOrgCases() {
  const { org } = useOrg();
  const { items, loading } = useOrgCollection<FinancingCase>(
    org?.id ?? null,
    SUBCOLLECTION_FINANCING_CASES
  );
  return { cases: items, loading };
}

export function useOrgApplications() {
  const { org } = useOrg();
  const { items, loading } = useOrgCollection<FinancingApplication>(
    org?.id ?? null,
    SUBCOLLECTION_FINANCING_APPLICATIONS
  );
  return { applications: items, loading };
}
